export enum TransportMode {
    Ocean = 'Ocean',
    Air = 'Air'
}